import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const Trips = ({ prRef }) => {
  const [data, setData] = useState([]);
  const getTrips = async () => {
    const response = await axios
      .get("trips/")
      .then((res) => {
        const tripsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver?.firstName} ${transaction.driver?.lastName}`;

          return {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver, name: driverName },
          };
        });

        setData(tripsWithMergedNames);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getTrips();
  }, []);

  const columns = [
    "Id",
    "Passenger Name",
    "Passenger Phone",
    "Driver Name",
    "Driver Phone",
    "Date",
  ];

  return (
    <div ref={prRef}>
      <Header
        title={"Trips Information"}
        subTitle={""}
      />
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((trip, index) => (
            <tr key={index}>
              <td style={thTdStyle}>{trip.id}</td>
              <td style={thTdStyle}>{trip?.passenger?.name}</td>
              <td style={thTdStyle}>{trip?.passenger?.phoneNumber}</td>

              <td style={thTdStyle}>{trip?.driver?.name}</td>
              <td style={thTdStyle}>{trip?.driver?.phoneNumber}</td>

              <td style={thTdStyle}>
                {new Date(trip.createdAt).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export const exportExcelTrips = async () => {
  const getTrips = async () => {
    const response = await axios
      .get("trips/")
      .then((res) => {
        const tripsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver?.firstName} ${transaction.driver?.lastName}`;

          return {
            Id: transaction.id,
            "Passenger Name": passengerName,
            "Passenger Phone": transaction.passenger?.phoneNumber,
            "Driver Name": driverName,
            "Driver Phone": transaction.driver?.phoneNumber,
            Date: new Date(transaction.createdAt).toLocaleString(),
          };
        });

        exportToExcel(tripsWithMergedNames, "trips", [
          "Id",
          "Passenger Name",
          "Passenger Phone",
          "Driver Name",
          "Driver Phone",
          "Date",
        ]);
      })
      .catch((err) => {});
  };

  getTrips();
};

export default Trips;
